import React from 'react';
import ReactDOM from 'react-dom';
import Search from './components/Search.jsx';

const { __, _x, _n, _nx } = wp.i18n;


if (document.querySelector('.app-search')) {
    ReactDOM.render(
        <Search/>,
        document.querySelector('.app-search'),
    );
}
